import React from 'react';
import { SignLayer } from './types';

export const LayersPanel: React.FC<{
  layers: SignLayer[];
  selectedId?: string;
  onSelect: (id: string) => void;
  onRename: (id: string, name: string) => void;
  onReorder: (id: string, index: number) => void;
  onToggleVisible: (id: string) => void;
  onToggleLocked: (id: string) => void;
}> = ({ layers, selectedId, onSelect, onRename, onReorder, onToggleVisible, onToggleLocked }) => (
  <aside aria-label="Layers" className="border border-gray-200 bg-white rounded-md p-2 space-y-1">
    <div className="text-xs font-semibold uppercase tracking-wide text-gray-500">Layers</div>
    {[...layers].reverse().map((layer, reverseIndex) => {
      const index = layers.length - reverseIndex - 1;
      return (
        <div key={layer.id} className={`flex items-center gap-1 p-1 border ${selectedId === layer.id ? 'border-emerald-500 bg-emerald-50' : 'border-transparent'}`}>
          <button aria-label={`Select ${layer.name}`} className="min-w-0 flex-1 text-left text-xs truncate" onClick={() => onSelect(layer.id)}>{layer.name}</button>
          <button aria-label={`${layer.visible ? 'Hide' : 'Show'} ${layer.name}`} onClick={() => onToggleVisible(layer.id)}>{layer.visible ? '◉' : '○'}</button>
          <button aria-label={`${layer.locked ? 'Unlock' : 'Lock'} ${layer.name}`} onClick={() => onToggleLocked(layer.id)}>{layer.locked ? '🔒' : '🔓'}</button>
          <button aria-label={`Move ${layer.name} up`} disabled={index === layers.length - 1} onClick={() => onReorder(layer.id, index + 1)}>↑</button>
          <button aria-label={`Move ${layer.name} down`} disabled={index === 0} onClick={() => onReorder(layer.id, index - 1)}>↓</button>
          <button aria-label={`Rename ${layer.name}`} onClick={() => { const name = window.prompt('Layer name', layer.name); if (name?.trim()) onRename(layer.id, name.trim()); }}>✎</button>
        </div>
      );
    })}
  </aside>
);
